<template>
  <el-dialog
    :visible.sync="dialogVisible"
    class="generate-signup-link"
    center
  >
    <el-row style="max-width: 90%;">
      <el-col>
        <el-radio-group v-model="iban">
          <el-radio-button label="yes">
            {{
              $t("generate-signup-link.iban-yes")
            }}
          </el-radio-button>
          <el-radio-button label="no">
            {{
              $t("generate-signup-link.iban-no")
            }}
          </el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col style="margin-top: 20px">
        <el-radio-group v-model="role">
          <el-radio-button label="employee">
            {{
              $t("generate-signup-link.employee")
            }}
          </el-radio-button>
          <el-radio-button label="owner">
            {{
              $t("generate-signup-link.owner")
            }}
          </el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col style="margin-top: 20px">
        <el-radio-group v-model="domain">
          <el-radio-button label="de">
            .de
          </el-radio-button>
          <el-radio-button label="es">
            .es
          </el-radio-button>
          <el-radio-button label="uk">
            .uk
          </el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="margin-top: 20px">
        <p class="link-preview">
          {{ signupLinkPreview }}
        </p>
        <el-button
          style="margin-top: 20px"
          @click="copyLink"
          round
          type="primary"
        >
          <i class="el-icon-document-copy" />
        </el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  props: {
    teamId: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iban: "yes",
      role: "employee",
      domain: "de",
    };
  },
  computed: {
    signupLinkPreview() {
      return `https://signup.tippie.${this.domain}?teamId=${this.teamId}&IBAN=${this.iban}&userRole=${this.role}`;
    },
    dialogVisible: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        this.$emit('update:visible', value);
      },
    },
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.signupLinkPreview);
      this.$message.success(this.$t("generate-signup-link.copied"));
    },
  },
  watch: {
    role(newRole) {
      if (newRole === "owner") {
        this.iban = "no";
      }
    },
  },
};
</script>
<style lang="scss">
.generate-signup-link {
  .el-dialog__header {
    padding: 0 !important;
  }
  .link-preview {
    line-height: 1.5;
    font-size: 12px;
    color: #000;
  }
}
</style>
